import ContentTable from "./ContentTable";
export default ContentTable;
